import { render, staticRenderFns } from "./DevFixes.vue?vue&type=template&id=1340c55c"
import script from "./DevFixes.vue?vue&type=script&lang=js"
export * from "./DevFixes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports